// Hocs
import asyncRoute from '../AsyncRoute'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-getting-started').GettingStarted
      resolve(View)

    /* Webpack named bundle   */
    }, 'hefty-getting-started')
  })
}

export default asyncRoute({getComponent, reducers: []})
